// extracted by mini-css-extract-plugin
export default {"imageWrapper":"MR-z","hovered":"NR-z","hoverImage":"OR-z","mainImage":"PR-z","imageNoBackground":"QR-z","fullSizeImage":"RR-z"};